<template>
  <div class="mhome-container">
    <div class="nav" :style="{ height: height }">
      <Nav @scroll-to-news="scrollToNews" />
    </div>
    <div class="more">
      <double-down theme="outline" size="24" fill="#fff" />
      <span>下滑查看更多</span>
    </div>
    <div class="banner">
      <Banner></Banner>
    </div>
    <div class="artshare" id="artshare" ref="artshare">
      <Artshare />
    </div>
    <div class="news" id="news" ref="news">
      <News />
    </div>
    <div class="room" id="room" ref="room">
      <Room />
    </div>
    <div class="artist" id="artist" ref="artist">
      <Artist />
    </div>
    <div class="app" id="app" ref="app">
      <AppDownload />
    </div>
    <div class="dataview" id="dataview" ref="dataview">
      <mDataView />
    </div>
    <div class="about" id="about" ref="about">
      <About />
    </div>
    <div class="footer" id="footer" ref="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Nav from './mNav'
import Banner from './mBanner'
import Artshare from './mArtshare'

import News from './mNews'
import Room from './mRoom'
import Artist from './mArtist'

import AppDownload from './mAppDownload'
import mDataView from './mDataView'

import About from './mAbout'
import Footer from './mFooter'

import { DoubleDown } from '@icon-park/vue'
export default {
  components: {
    Nav,
    Banner,
    Artshare,
    News,
    Room,
    Artist,

    AppDownload,
    mDataView,
    About,
    Footer,
    DoubleDown

  },
  data () {
    return {
      height: '66px', // 初始高度为 80px
      prevScrollTop: 0 // 用于记录上一次的滚动位置
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const banner = document.querySelector('.banner')
      if (banner) {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
        const isScrollingUp = currentScrollTop < this.prevScrollTop
        // const bannerTop = banner.getBoundingClientRect().top

        // Bug 修复：只要向上滑动屏幕，就让height的值为66px
        if (isScrollingUp) {
          this.height = 66 + 'px'
        } else {
          this.height = 0 + 'px'
        }

        this.prevScrollTop = currentScrollTop
      }
    },
    scrollToNews (link) {
      this.$nextTick(() => {
        if (link === 'scroll-to-news') {
          // 将 news 元素滚动到页面顶部
          this.$refs.news.scrollIntoView({ behavior: 'smooth' })
        }
        if (link === 'scroll-to-app') {
          // 将 news 元素滚动到页面顶部
          this.$refs.app.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
        }
        if (link === 'scroll-to-about') {
          // 将 news 元素滚动到页面顶部
          this.$refs.about.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
          console.log(this.height)
        }
        if (link === 'scroll-to-artshare') {
          // 将 news 元素滚动到页面顶部
          this.$refs.artshare.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
          console.log(this.height)
        }
        if (link === 'scroll-to-artist') {
          // 将 news 元素滚动到页面顶部
          this.$refs.artist.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
          console.log(this.height)
        }
        if (link === 'scroll-to-dataview') {
          // 将 news 元素滚动到页面顶部
          this.$refs.dataview.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
          console.log(this.height)
        }
        if (link === 'scroll-to-room') {
          // 将 news 元素滚动到页面顶部
          this.$refs.room.scrollIntoView({ behavior: 'smooth' })
          this.height = 66 + 'px'
          console.log(this.height)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/* 隐藏滚动条整体 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: transparent;
}

/* 针对 Firefox 浏览器 */
html {
  scrollbar-width: none;
}

/* 针对 IE 和 Edge 浏览器 */
body {
  -ms-overflow-style: none;
}

.mhome-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #EFF1FD;
  box-sizing: border-box;

  .more {
    position: fixed;
    bottom: 20px;
    left: 50%;
    z-index: 999;
    color: white;
    transition: filter 0.3s;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    font-weight: 600;
    transform: translateX(-50%);
    display: flex;
    align-items: center;

  }

  .nav {
    position: fixed;
    width: 100%;
    transition: all .5s;
    z-index: 999;
  }

  .banner {
    width: 100%;
    height: 100vh;
  }

  .artshare {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .news {
    width: 100%;
    height: 100vh;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .room {
    width: 100%;
    height: 100vh;
  }

  .artist {
    width: 100%;
    height: 100vh;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .app {
    width: 100%;
    height: 100vh;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }

  .dataview {
    width: 100%;
    height: 100vh;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }

  .about {
    width: 100%;
    height: auto;
    background-image: url('~@/assets/img/m-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;

  }

  .footer {
    width: 100%;
    height: auto;
    background-color: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>